/* eslint-disable react-hooks/exhaustive-deps */
import TableContainer from "../../Components/Table";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getClosure } from "../../api/common";
import SubmitButton from "../../Components/Button";
import { AUDIT_MODES, ERROR_MESSAGE } from "../../constants";
import {
  calculateOffset,
  getAuditLevelLabel,
  getUniqueAppNames,
} from "../../utils";
import PageContainer from "../PageContainer";
import Review from "../../icons/reviewDetailIcon.svg?react";
import Alert from "../../Components/AlertPopup";
import OrganizationList from "../../Components/OrgModal/OrganizationList";
import Info from "../../icons/infoIcon.svg?react";
import AuditInformationModal from "../../Components/InfoModal/AuditInformationModal";
import styles from "./style.module.scss";

const AuditCompleted = () => {
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<[]>([]);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10); // Default page size
  const [showInfo, setShowInfo] = useState(false);
  const [element, setElement] = useState([]);

  const navigate = useNavigate();

  const columnData = [
    { label: "No", key: "no" },
    { label: "Audit ID", key: "auditCode" },
    {
      label: "Organization",
      key: "orgDetails",
      tdClassname: "text-start wrapTheme",
    },
    {
      label: "Application",
      key: "applicationList",
      tdClassname: "text-start wrapTheme",
    },
    { label: "Theme", key: "theme", tdClassname: "text-start wrapTheme" },
    { label: "Level", key: "auditLevel", tdClassname: "text-center" },
    {
      label: "Duration",
      key: "duration",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Response Time", key: "responseTime", isMoreField: true },
    {
      label: "Reminder Alert",
      key: "escalationFrequency",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Questionnaire Response", key: "action", disableSortBy: true },
    { label: "Info", key: "info", disableSortBy: true },
  ];

  const MoreFeildsValue = [
    { label: "Duration", value: "duration" },
    {
      label: "Response Time",
      value: "responseTime",
      tdClassname: "text-start",
    },
    { label: "Reminder Alert", value: "escalationFrequency" },

  ];

  useEffect(() => {
    // eslint-disable-next-line
    fetchData(1);
  }, []);
  const handleErrorClose = () => setShowErrorToast(false);

  const fetchData = async (pageNumber: number) => {
    setLoading(true);
    const finalSet: any = [];
    getClosure(calculateOffset(pageNumber))
      .then((response) => {
        if (response) {
          let i = 1;
          response.forEach((element: any) => {
            finalSet.push({
              ...element,
              no: i,
              auditMode: AUDIT_MODES[element.auditMode],
              auditLevel: `${getAuditLevelLabel(element.auditLevel)} (${element.auditLevel})`,
              duration: `${element.startDate?.split("-")?.reverse()?.join("/")} - ${element.endDate?.split("-")?.reverse()?.join("/")}`,
              escalationFrequency: element.escalationFrequency ? `${element.escalationFrequency} Days` : "-",
              responseTime: `${element.responseTime} Days`,
              applicationList: getUniqueAppNames(element.organizations),
              action: (
                <SubmitButton
                  onClick={() =>
                    navigate("/closure/review-details/" + element.auditingId, {
                      state: { from: "/closure", fromLabel: "Audit Closure" },
                    })
                  }
                >
                  <Review className="reviewbtnIcons" />
                  &nbsp;&nbsp;View Details
                </SubmitButton>
              ),
              theme: element.themes
                .map((data: any) => data?.themeName)
                .join(", "),
              orgDetails: (
                <OrganizationList
                  title="Organization Under Audit ID:"
                  auditCode={element.auditCode}
                  organizations={element.organizations}
                />
              ),
              info: (
                <span>
                  <Info
                    className={styles.iconStyleActions}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowInfo(true);
                      setElement(element);
                    }}
                  />
                </span>
              ),
            });
            i++;
          });
        }
        setRowData(finalSet);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setShowErrorToast(true);
      });
  };
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPageSize(newLimit);
    setCurrentPage(1); // Reset to first page on limit change
  };
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentClosure = rowData.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <PageContainer>
      <div className={styles.title}>Audit Closure</div>

      <div className={styles.actionItem}>
        <div className={styles.tabs}></div>
      </div>

      <div>
        <TableContainer
          columnData={columnData}
          rowData={currentClosure}
          totalResult={rowData.length}
          enableMoreFeilds={true}
          MoreFeildsValue={MoreFeildsValue}
          title={"List of Audits for Closure"}
          enableActionButton={false}
          enableFilter={true}
          itemsPerPage={pageSize}
          currentPage={currentPage}
          setCurrentPage={(pageNumber) => {
            setCurrentPage(pageNumber);
            fetchData(pageNumber);
          }}
          onPageNoChange={handlePageChange}
          onPageLimitChange={handlePageSizeChange}
          showLoading={loading}
          noRecordMessage={"There are no audits in the closure stage."}
        />
      </div>
      <Alert
        type="error"
        show={showErrorToast}
        onClose={handleErrorClose}
        message={ERROR_MESSAGE.API_ERROR_MESSAGE}
      />
      <AuditInformationModal
        element={element}
        show={showInfo}
        onHide={() => setShowInfo(false)}
      />
    </PageContainer>
  );
};

export default AuditCompleted;
